import React, { useCallback, HTMLAttributes } from 'react';

import { WEEK_DAYS } from '../../constants/WEEK_DAYS';

import { AvailabilityDetails } from '../../hooks/simpleProduct';

import { Container } from './styles';

type WeekDaysProps = HTMLAttributes<HTMLDivElement> & {
  selectedDays: AvailabilityDetails['days'];
  onChangeDays(weekDays: AvailabilityDetails['days']): void;
};

const WeekDays: React.FC<WeekDaysProps> = ({
  selectedDays,
  onChangeDays,
  ...rest
}) => {
  const handleToggleWeekDay = useCallback(
    (weekDay: keyof AvailabilityDetails['days']) => {
      onChangeDays({
        ...selectedDays,
        [weekDay]: !selectedDays[weekDay],
      });
    },
    [selectedDays, onChangeDays],
  );

  return (
    <Container {...rest}>
      {Object.keys(WEEK_DAYS).map((weekDay) => (
        <button
          key={weekDay}
          type="button"
          className={
            selectedDays[weekDay as keyof AvailabilityDetails['days']]
              ? 'active'
              : ''
          }
          onClick={() =>
            handleToggleWeekDay(weekDay as keyof AvailabilityDetails['days'])
          }
        >
          {WEEK_DAYS[
            weekDay as keyof AvailabilityDetails['days']
          ].toUpperCase()}
        </button>
      ))}
    </Container>
  );
};

export default WeekDays;
